import React from 'react'
import PropTypes from 'prop-types'
import IconLabel from './IconLabel'
import {CheckSquareFilled} from '@ant-design/icons'

const StandardPhotoProduct = ({product}) => {
  if (product.residence) {
    return (
      <div className="selected-product-options StandardPhotoProduct">
        <IconLabel icon={<CheckSquareFilled />} label="Residence" />
      </div>
    )
  }

  return null
}

StandardPhotoProduct.propTypes = {
  product: PropTypes.object.isRequired,
}

export default StandardPhotoProduct
